import { assign, createMachine, InterpreterFrom } from 'xstate'

type UnknownContext = {
  errorMessage: undefined
}

type InvalidContext = {
  errorMessage: string
}

type ValidationContext = { errorMessage?: string }

export type ValidationTypestate =
  | {
      value: 'unknown'
      context: UnknownContext
    }
  | {
      value: 'invalid'
      context: InvalidContext
    }

type InvalidateEvent = {
  type: 'INVALIDATE'
  errorMessage: string
}

type ClearEvent = {
  type: 'CLEAR'
}

export type ValidationEvent = InvalidateEvent | ClearEvent

export const validationMachine = createMachine<
  ValidationContext,
  ValidationEvent,
  ValidationTypestate
>({
  id: 'validation',
  initial: 'unknown',
  context: {},

  states: {
    unknown: {
      on: {
        INVALIDATE: {
          target: 'invalid',
          actions: assign({
            errorMessage: (context, event) => event.errorMessage,
          }),
        },
      },
    },

    invalid: {
      on: {
        CLEAR: {
          target: 'unknown',
          actions: assign({
            errorMessage: undefined,
          }),
        },
      },
    },
  },
  predictableActionArguments: true,
})

export type ValidationInterpreter = InterpreterFrom<typeof validationMachine>
